<template>
	<div class="spinner"></div>
</template>

<script setup>
	const { getAppUrl } = useApiRoutes();

	onMounted(async () => {
		await navigateTo(getAppUrl("auth_login"));
	});
</script>

<style lang="less" scoped>
	.spinner{width: 40px; height: 40px; background: url(assets/images/loader.svg) no-repeat center; background-size: 40px; z-index: 1;}
</style>
